<template>
  <div class="preview-container" :class="{'hidden':changeId===2}"
  >
    <Header  @handler="handler" @logOut="logOut" :userName="userName" :changeId="changeId"></Header>
    <div class="detail" :class="{'detail-Tablet':isTablet}">
      <!-- 预习中心 -->
      <div class="preview-detail" v-if="changeId===2"  v-loading="loading"
      element-loading-background="#fff">
        <div class="preview-left">
          <div class="preview-arrow">
              <span @click="goList">
                <i
                  class="el-icon-arrow-left"
                ></i
                >返回
              </span>
          </div>
          <div class="preview-content">
            <div class="preview-line"></div>
            <p class="preview-name">{{previewName}}
            </p>
          </div>
          <div class="preview-list">
            <div class="preview-item" v-for="(item,i) in previewList" :key="i"
            :class="{'active-item':activeNum===i}"
            @click="clickPlayer(item.videoUrl,i)"
            >
            <div class="preview-img" >
              <div class="priview-button">
                <img src="../images/button.png" alt="">
              </div>
              <img src="../images/video.png" alt="">

              </div>
            <div class="preview-tag">
              <p class="preview-p">{{item[0].tagName}}</p>
              <span class="preview-finish" v-if="item.some(i=>i.singleVideoIsPlayHalf===1)
              "
              >已预习</span>
            </div>
            <div class="preview-num" style="display:none">
              <span>学习人数:1000</span>
            </div>
          </div>
          </div>

        </div>
        <div class="preview-right">
          <VideoDetail
          ref="video"
          :videoUrl="videoUrl"
          :previewList="previewList"
          @changeNum="changeNum"
          :activeNum="activeNum"
          ></VideoDetail>
        </div>
      </div>
      <div  v-loading="loading"
      v-if="tabShow"
        element-loading-background="#fff">
        <div class="detail-header" >
          <div class="detail-tabs">
            <Tabs
            @changeSubject="changeSubject"
            :subject_list="subject_list"
            :activeId="activeId"></Tabs>
          </div>
          <div class="detail-header_class">
            <span >{{className}}</span>
            <el-dropdown trigger="click" @command="changeClass">
              <span class="el-dropdown-link">
                <i
                  class="el-icon-refresh el-icon--left"
                ></i
                >切换班级
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                :class="{active:item.class_name===className}"
                v-for="(item,index) in classList" :key="index" :divided="index>0"
                :command="item.class_name"
                >{{item.class_name}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>

      <!-- 测评列表 -->
      <div v-if="changeId===1"  v-loading="loading"
        element-loading-background="#fff" class="testList">
          <div class="practice-status">
            <span class="testStatus">
              <span :class="['practice-all',
                {'active':testId===2}]" @click="changeTest(2)">查看未完成</span>
              <span :class="['practice-unfinished',
                {'active':testId===1}]" @click="changeTest(1)">查看已完成</span>
            </span>
          </div>

          <div class="detail-wrap" v-if="testId==2">
            <div class="detail-wrap_di" >
              <img src="../images/di.png" alt="" />
            </div>
            <div class="detail-wrap_title">未完成的测评</div>
          </div>
          <unfinished-test :activeId="activeId" :unfinishedList="unfinishedList"
            v-if="testId==2" @applyOne='applyOne' :pageSize="pageSize"
            @changePageSize="changePageSize"
            @changeCurrent="changeCurrent"
            :total="total"></unfinished-test>

          <div class="detail-wrap" v-if="testId==1">
            <div class="detail-wrap_un"><img src="../images/di.png" alt="" /></div>
            <div class="detail-wrap_title">已完成的测评</div>
          </div>
          <finished-content :activeId="activeId" :finishedList="finishedList"
            ref="finishedContent"
          v-if="testId==1"></finished-content>
      </div>

      <!-- 练习中心 -->
      <div class="prepare-record" v-if="changeId===3"  v-loading="loading"
        element-loading-background="#fff">
        <div class="practice-center">
        <div class="practice-wrap" >
        <div class="practice-wrap_di"><img src="../images/di.png" alt="" /></div>
        <div class="practice-wrap_title">我的练习</div>
        </div>
        <div class="practice-status">
          <span :class="['practice-all',
          {'active':practiceId===0}]" @click="changePractice(0)">查看全部</span>
          <span :class="['practice-unfinished',
          {'active':practiceId===2}]" @click="changePractice(2)">仅看未完成</span>
        </div>
    </div>
        <practice-center
        :activeId="activeId"
        :prevList="praList"
        @applyOne='applyOne' :pageSize="pageSize" @changePageSize="changePageSize"
        ></practice-center>
      </div>
    </div>
  </div>

</template>

<script>
/* eslint-disable */
import api from '@/pages/uc-web/api/api';
import { getSign } from '@/pages/uc-web/utils/verify';
import Header from '../components/header.vue';
import VideoDetail from '../components/video-detail.vue';
import FinishedContent from '../components/finished-content.vue';
import UnfinishedTest from '../components/unfinished-test.vue';
import Tabs from '../components/tabs.vue';
import PracticeCenter from '../components/practice-center.vue';
import { userAgentType } from '@/utils/index';

export default {
  name: 'CheckPreview',
  components: {
    Header,
    VideoDetail,
    UnfinishedTest,
    FinishedContent,
    Tabs,
    PracticeCenter
  },
  data() {
    return {
      previewList:[],
      userName : localStorage.getItem('real_name') || '', // 用户名
      activeId: '0', // 当前点击的id
      list: [], // 测试列表
      preList:[],//预习列表
      praList:[],//练习列表
      params: {}, // 测试列表参数
      classList: [], // 班级列表
      subjectList: [], // 科目列表
      className: '', // 显示班级名称
      class_name: '', // 班级名
      lastInfo: {}, // 最后一次班级测评的信息
      loading: false, // 加载
      changeId: 2, // 头部tab Id
      previewItem: {},
      videoUrl: '', // 视频播放地址
      activeNum: 0, // 当前播放视频下标
      newVal: 0, // 当前的最新值
      oldVal: 0, // 之前的值
      previewName:localStorage.getItem('evaluate_name') || '',
      testId:2,
      practiceId:0,//练习完成状态
      pageSize:10,
      currentPage:1,
      total:0,
      pageCount:0,
      isTablet: false,
    };
  },
  created() {
    this.hwId = this.$route.query.hwId;
  },
  mounted(){
    this.getPreviewList();
    this.isTablet = userAgentType().isTablet;

  },
  methods: {
    async getStuInfoAfterLogin(i){
      this.loading = true
      try {
        const params = {
        // school_id:2217,
        school_id:localStorage.getItem('school_id'),
        // account_id:8885623813293003,
        account_id:localStorage.getItem('account_id'),
        type:i
        }
      const res = await api.getStuInfoAfterLogin(params)
      this.subjectList=res.data.subject_list||[];
      this.classList = res.data.class_list || []

      //获取上次测试的班级信息
      const result = await api.getLastInfo(params);
      this.lastInfo = result.data
      // console.log(result.data.class_name)
      this.className =
      result.data.class_name || this.classList[0].class_name || ''
      this.class_id =
      result.data.class_id || this.classList[0].class_id || ''
      } catch (error) {
      }
      this.loading=false;
      this.getTestInfo(i);
    },
    // 切换科目
    changeSubject(subjectId) {
      this.activeId = subjectId;
    },
    // 切换测评状态
    changeTest(i){
      this.testId = i;
      this.practiceId=this.testId;
      console.log('我改变了!!!!!!!',this.testId);
      if (this.testId==1) {
        this.$nextTick(() => {
          this.$refs.finishedContent && this.$refs.finishedContent.handleCurrentChange(1);
        });
      }
      this.getTestInfo(this.changeId);
    },
    // 切换班级
    changeClass(command) {
      console.log(command);
      this.className = command;
      this.activeId = '0';
    },
    // 头部tab切换
    handler(i) {
      this.changeId = i;
      this.activeId = '0';
      this.activeNum = 0
      if(this.changeId===2){
        //获取学生登陆后信息
        this.getStuInfoAfterLogin(2);
        // this.getTest()
      }
      if (this.changeId===1) {
        this.practiceId=2;
        this.getStuInfoAfterLogin(1);
        // this.getTestInfo()
      }
      if (this.changeId===3) {
        this.practiceId=0;
        this.getStuInfoAfterLogin(3);
        // this.getTestInfo()
      }
    },
    //更改每页显示个数,重新发请求
    changePageSize(val){
      this.pageSize = val;
      this.getTestInfo(this.changeId);
    },
    changeCurrent(val){
      this.currentPage=val;
      this.getTestInfo(this.changeId);
    },
    // 切换练习状态
    changePractice(i){
      this.practiceId = i;
      this.getTestInfo(this.changeId);
    },
    logOut(){
      this.$refs.video.VideoProgress()
    },
    // 获取预习视频列表
    async getPreviewList() {
      this.previewList = []
      this.loading = true
      try {
        const params = {
        hwId: this.hwId,
        groupId: 0,
      };
      const res = await api.getPreviewList(params);
      const tagCodeList = res.data.tagCodeList || {}
      Object.keys(tagCodeList).forEach((key, index) => {
        this.previewList.push(tagCodeList[key])
      })
      } catch (error) {
        console.log(error)
      } finally {
      this.loading = false
      }
    },
    applyOne() {
      this.showType = true;
    },
    //获取预习/测评/练习列表
    async getTestInfo(i) {
      this.loading = true
      try {
        const params = {
          // school_id:2217,
          school_id:localStorage.getItem('school_id'),
          // account_id:8885623813293003,
          account_id:localStorage.getItem('account_id'),
          type:i,
          class_id:this.class_id,
          subject_id:this.activeId, //0 全部
          // task_status:this.practiceId,//0 全部 1已完成 2进行中
          task_status:this.changeId==2?0:this.practiceId,
          page_size:this.pageSize,
          curr_page:this.currentPage,
          sort:0
        }
        const res = await api.getStuTaskListById(params)
        this.userName = localStorage.getItem('real_name')
        if (i==2) {
          this.preList = res.data.list || []
        } else if(i==1){
          this.list=res.data.list || []
        }else{
          this.praList=res.data.list || []
        }
        this.total=res.data.total;
        this.pageCount=res.data.total_page;

        // this.subjectList = res.data.subject_list || []

        // //获取上次测试的班级信息
        // const result = await api.getLastInfo(params);
        // this.lastInfo = result.data
        // this.className =
        // result.data.class_name || this.classList[0].class_name || ''
      } catch (error) {
          console.log(error)
      } finally{
          this.loading = false
      }

    },
      // 练习列表渲染
    practiceList(){
      let arrList =  this.praList.filter(item=>item.class_name!='')
       return arrList.sort(function(a, b) {
          return b.created < a.created ? -1 : 1
      })
    },

    // 点击视频列表
    clickPlayer(videoUrl, i) {
      this.$refs.video.VideoProgress()
      this.videoUrl = videoUrl;
      this.activeNum = i;
    },
    // 改变当前下标
    changeNum(num) {
      this.activeNum = num;
      if (this.newVal > 0 && this.newVal > this.oldVal) {
        document.querySelector('.preview-list').scrollTop += 250
      }
      if (this.newVal < this.oldVal && this.newVal < this.previewList.length - 1) {
        document.querySelector('.preview-list').scrollTop -= 250;
      }
    },
    goList(){
      localStorage.setItem('changeId', 2);
      window.history.go(-1);
    }
  },
  computed: {
    tabShow(){
      return !(this.changeId===2 && this.$route.path=='/uc-web/preview')
    },
    // 获取展示的科目列表
    subject_list() {
      const newData = [];
      Object.keys(this.subjectList).forEach((key, index) => {
        newData.push({
          subjectId: key,
          subjectName: this.subjectList[key],
        });
      });
      return newData;
    },
    // 测评列表
    testList() {
      const arrList = this.list.filter((item) => item.class_name === this.className);
      return arrList.sort((a, b) => (b.created < a.created ? -1 : 1));
    },
    // 未完成列表
    unfinishedList() {
      return this.testList.filter((item) => item.evaluate_status === 2);
    },
    // 已完成列表
    finishedList() {
      const arr = this.testList.filter((item) => item.evaluate_status === 1);
      return arr.sort((a, b) => (b.end_time < a.end_time ? -1 : 1));
    },
    // 默认图片
    // defaultImg() {
    //   return `this.src="${require('@/views/uc-web/images/video.png')}"`;
    // },
    previewlength(){
      return this.previewName.length
    }
  },
  watch: {
    activeNum(newVal, oldVal) {
      this.newVal = newVal;
      this.oldVal = oldVal;
    },
    loading(){
      console.log('loading变化了');
    }
  },
};

</script>
<style lang="scss" scoped>
  .hidden{
    width: 100%;
    height: 100%;
    overflow-y:hidden;
  }
.preview-container{
  padding-top: 64px;
  padding-bottom:20px ;
  font-family: PingFangSC-Medium, PingFang SC;

  .preview-detail{
    // width: 1118px;
    // height: 100px;
    height: 100%;
    // margin: 16px auto;
    display: flex;
    justify-content: space-between;

    .preview-left{
      width: 360px;
      // height: 664px;
      background: #fff;
      padding: 24px;
      height: 100%;
      overflow: auto;
      .preview-arrow{
        color: #606266;
        font-weight: 500;
        font-size:16px;
        margin-bottom:20px;
        cursor: pointer;
      }
      .preview-content{
        // position: fixed;
        margin-bottom: 32px;
        position: relative;
        display: inline-block;

        .preview-line{
          position: absolute;
          left: 0px;
        top: 5px;
        width: 3px;
        height: 16px;
        background: #1890FF;
        border-radius: 3px;
        }
      .preview-name{
        font-size: 18px;
        font-weight: 500;
        color: #000000;
        position: relative;
        margin-left: 8px;
        overflow: hidden;
        text-overflow:ellipsis;
        display: -webkit-box;
        -webkit-line-clamp:1 ;
        -webkit-box-orient:vertical  ;
        .bgc{
          width: 100%;
          height: 14px;
        background: rgba(230, 162, 60, 0.2);

        }
      &::after{
        position: absolute;
        content: "";
        left: 0px;
        top: 8px;
        width: 100%;
        height: 13px;
        background: rgba(230, 162, 60, 0.2);
        border-radius: 7px;
      }
    }
  }
  .preview-list{
    width:286px;
    // height: 100%;
    overflow-y:auto;
    .preview-item{
      width: 240px;
      height: 223px;
      background: #FFFFFF;
      box-shadow: 2px 2px 3px 0px rgba(226, 232, 241, 0.56);
      border-radius: 6px;
      // border: 1px solid #EBEEF5;
      margin-bottom: 12px;
       cursor: pointer;
      .preview-img{
        position: relative;
        .img{
          width: 100%;
          height: 135px;
          display: block;
       }
       .priview-button{
         position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50%,-50%);
       }
      }
      .preview-tag{
        width: 100%;
        padding: 11px 17px 0 18px;
        font-size: 15px;
        .preview-p{
          overflow: hidden;
          text-overflow:ellipsis;
          display: -webkit-box;
          -webkit-line-clamp:2;
          -webkit-box-orient:vertical;
        }
       .preview-finish{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 50px;
          height: 18px;
          background: #0DD4C8;
          border-radius: 4px;
          font-size: 10px;
          color: #FFFFFF;
        }
        }
        .preview-num{
          width: 100%;
          padding: 8px 17px 0 18px;
          font-size: 12px;
          color: #606266;
        }
    }
    .active-item{
      border-radius: 10px;
      border: 3px solid #24A1FF;
    }
  }
  }
  .preview-right{
    width: 746px;
    // height: 664px;
    background: #fff;
    height: 100%;
    overflow-y: auto;
  }
  }
}
.detail {
  width: 1118px;
  height: calc(100vh - 120px);
  overflow: hidden;
  margin: 16px auto;
  background: #fff;
  padding: 0 19px 0 20px;
  box-sizing: border-box;
  font-family: PingFangSC-Medium, PingFang SC;
  &-header {
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    background-color: #fff;
    border-bottom: 1px solid #ebeef5;
    &_class {
      span {
        font-size: 16px;
        font-weight:500;
        color: #000000;
      }
    }
    .el-dropdown-link {
      font-size: 14px;
      color: #1989FA;
      margin-left:22px;
      cursor: pointer;
    }
  }
  &-wrap {
    width: 100%;
    height: 51px;
    position: relative;
    &_di {
      margin-top: 24px;
    }
    &_un {
      margin-top: 24px;
    }
    &_title {
      position: absolute;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      top: 5px;
      left: 13px;
    }
  }
}
.practice-status{
  position: relative;
    font-size: 13px;
    color: #303133;
    .practice-all{
      display: inline-block;
      width: 84px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      border: 1px solid #C0C4CB;
      border-right: none;
    }
     .practice-unfinished{
      display: inline-block;
      width: 84px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      border: 1px solid #C0C4CB;
      border-left: none;
    }
    .active{
    color: #1989FA;
    border: 1px solid #1989FA;
    }
}
.testStatus{
  display: inline-block;
  height: 30px;
  position: absolute;
  right: 0;
  z-index: 999;
}
.testList{
  padding-top: 25px;
  min-height: 715px;
}
.el-dropdown-menu{
font-weight: 500;
color: #010101;
}
.el-icon-refresh:before{
  font-weight:500 ;
}
.active{
  color: #1989FA;
}
.practice-center{
  height: 77px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  .practice-wrap_title{
    position: absolute;
    left: 16px;
    top: 25px;
    font-size: 17px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
  }
}

</style>
